import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=d6756b40&scoped=true"
import script from "./AddRole.vue?vue&type=script&lang=js"
export * from "./AddRole.vue?vue&type=script&lang=js"
import style0 from "./AddRole.vue?vue&type=style&index=0&id=d6756b40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6756b40",
  null
  
)

export default component.exports